(function () {
    'use strict';

    angular.module('UndergroundWebApp').factory('containerItemTypesService', containerItemTypesService);

    containerItemTypesService.$inject = ['$q', '$http'];

    function containerItemTypesService($q, $http) {
        var service = {
            addContainerItemType: addContainerItemType,
            updateContainerItemType: updateContainerItemType,
            getContainerItemTypes: getContainerItemTypes
        };

        return service;

        function addContainerItemType(containerItemType) {
            var deferred = $q.defer();

            $http.post("api/containerItemType", containerItemType).then(
                function (result) {
                    if (result && result.data) {
                        deferred.resolve(result.data);
                    } else {
                        deferred.reject();
                    }
                },
                function () {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        function updateContainerItemType(containerItemType) {
            var deferred = $q.defer();

            $http.put("api/containerItemType", containerItemType).then(
                function (result) {
                    if (result && result.data) {
                        deferred.resolve(result.data);
                    } else {
                        deferred.reject();
                    }
                },
                function () {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        function getContainerItemTypes() {
            var deferred = $q.defer();

            $http.get("api/containerItemType").then(
                function (result) {
                    if (result && result.data) {
                        deferred.resolve(result.data);
                    } else {
                        deferred.reject();
                    }
                },
                function () {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }
    }
})();
